import { render, staticRenderFns } from "./add-item-dialog.vue?vue&type=template&id=8d79f2ae&scoped=true&"
import script from "./add-item-dialog.vue?vue&type=script&lang=js&"
export * from "./add-item-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d79f2ae",
  null
  
)

export default component.exports